module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only aligner",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md1": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 50,
      "imaSrc": "contenido/diapositiva_54",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('h1', {
    staticClass: "big-font font-red davi-curs"
  }, [_vm._v("Tips")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¡Felicitaciones, ha creado su patrimonio!',
      "videoEmbed": "ADMINISTRACIONDINERO55Tipsb.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "light-dark-int",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("\r\n        Los cambios positivos en las finanzas personales y familiares se logran si se realizan los siguientes ejercicios de forma periódica. Haciendo clic sobre los números podrá descubrir un nuevo tip:")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "adorn-bottom",
    attrs: {
      "row": "",
      "wrap": "",
      "mb-5": ""
    }
  }, [_c('bots-numbers-bottom', {
    attrs: {
      "numeroBotones": 6
    }
  }, _vm._l((_vm.textos), function(item, index) {
    return _c('div', {
      attrs: {
        "slot": 'cont' + index
      },
      slot: 'cont' + index
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "md2": "",
        "lg2": "",
        "text-xs-center": ""
      }
    }, [_c('ui-circle-span', {
      staticClass: "animated rotateIn",
      attrs: {
        "botProp": [index + 1, '', 'back-red'],
        "aria": 'numero ' + (index + 1)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "animated fadeInRight",
      attrs: {
        "xs12": "",
        "sm9": "",
        "md8": "",
        "lg7": ""
      }
    }, [_c('p', [_vm._v(_vm._s(item))])])], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7f493b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-55.vue
// module id = 1027
// module chunks = 1